// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import '@babel/polyfill'
import 'vue-simple-suggest/lib/polyfills'
import App from './App'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import './assets/css/loginavi.scss'
import router from './router'
import store from '@/store/index.js'
import sanitizeHTML from 'sanitize-html'
import './assets/css/theme.scss'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import './assets/css/logico2.sass'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faExchangeAlt,
  faArrowCircleUp,
  faArrowCircleRight,
  faTruck,
  faCamera,
  faEye,
  faPenFancy,
  faSync,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueScrollTo from 'vue-scrollto'
import ToggleButton from 'vue-js-toggle-button'
import Paginate from 'vuejs-paginate'
import VueMq from 'vue-mq'
import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate/dist/vee-validate.full'
import ja from '../static/lang/vee-validate/ja.js'
import {
  tel,
  fax,
  date,
  time,
  zenkaku,
  notEmoji,
  katakana,
  password,
  hanKatakana,
  moji,
  hiragana,
  byte,
  char,
  hanAlphaNum,
  hanAlphaNumKigo,
} from '@/veeValid.js'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ja'
Vue.use(DatePicker)

import VueGtag from 'vue-gtag'
if (process.env.NODE_ENV === 'production') {
  Vue.use(VueGtag, {
    config: { id: 'G-68X0VXVBV4' },
  })
}

// レスポンシブ設定
const breakpoints = {
  sp: 767,
  pc: 1024,
}
Vue.use(VueMq, { breakpoints })

Vue.config.productionTip = false

Vue.use(ToggleButton)
Vue.use(VueMaterial)
Vue.use(BootstrapVue)
Vue.use(VueScrollTo)
Vue.prototype.$sanitize = sanitizeHTML

library.add(
  faExchangeAlt,
  faArrowCircleUp,
  faArrowCircleRight,
  faTruck,
  faCamera,
  faEye,
  faPenFancy,
  faSync
)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('paginate', Paginate)

extend('tel', tel)
extend('fax', fax)
extend('date', date)
extend('time', time)
extend('zenkaku', zenkaku)
extend('notEmoji', notEmoji)
extend('katakana', katakana)
extend('hanKatakana', hanKatakana)
extend('moji', moji)
extend('password', password)
extend('hiragana', hiragana)
extend('byte', byte)
extend('char', char)
extend('hanAlphaNum', hanAlphaNum)
extend('hanAlphaNumKigo', hanAlphaNumKigo)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
localize('ja', ja)

/* ここまで */

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js